import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { TransactionIdRenderer } from '../TransactionIdRenderer/TransactionIdRenderer';
import { StatusBadge } from 'components/StatusBadge/StatusBadge';
import { StatusBadgeState } from 'components/StatusBadge/SatusBadge.types';
import { AmountRenderer } from 'components/AmountRenderer/AmountRenderer';
import { NetworkRenderer } from 'components/NetworkRenderer/NetworkRenderer';
import { DESTINATION_CHAINS, SOURCE_CHAINS, } from 'pages/TransferPage/TransferPage.constants';
import { Token } from 'pages/TransferPage/TransferPage.types';
export const COLUMNS_CONFIG = [
    {
        id: 'origin',
        title: 'Origin',
        cellRenderer: () => (_jsx(NetworkRenderer, { network: SOURCE_CHAINS[0], iconSize: 20 })),
        className: 'hidden lg:table-cell',
    },
    {
        id: 'destination',
        title: 'Destination',
        cellRenderer: (tx) => {
            const targetChain = DESTINATION_CHAINS.find(d => d.label === tx.targetChain);
            return targetChain ? (_jsx(NetworkRenderer, { network: targetChain, iconSize: 20 })) : (_jsx(_Fragment, { children: "Unsupported chain" }));
        },
    },
    {
        id: 'amount',
        title: 'Amount',
        className: 'min-w-40',
        cellRenderer: (tx) => (_jsx(AmountRenderer, { value: tx.amount, suffix: Token.BTC, decimals: 10, precision: 8 })),
    },
    {
        id: 'originTxid',
        title: 'Origin TXID',
        cellRenderer: (tx) => (_jsx(TransactionIdRenderer, { hash: tx.originTxid, chainId: tx.originChain })),
    },
    {
        id: 'targetTxid',
        title: 'Destination TXID',
        cellRenderer: (tx) => {
            const targetChain = DESTINATION_CHAINS.find(d => d.label === tx.targetChain);
            if (!targetChain) {
                return _jsx(_Fragment, { children: "Unsupported chain" });
            }
            return (_jsx(TransactionIdRenderer, { hash: tx.targetTxid, chainId: targetChain.id }));
        },
    },
    {
        id: 'status',
        title: 'Status',
        cellRenderer: (tx) => (_jsx(StatusBadge, { state: tx.status === 'completed'
                ? StatusBadgeState.completed
                : StatusBadgeState.pending, label: tx.status === StatusBadgeState.completed ? 'Completed' : 'Pending' })),
    },
];
